module.exports = __webpack_public_path__ + "static/media/camp1.56f44e61.jpeg";